import localVi from './lang/vi.json'
import localEn from './lang/en.json'

export const messages = {
  vi: localVi,
  en: localEn,
}
